import { Context } from '~/types/ext/vue'

export const requireIssueCode = (ctx: Context): void => {
  if (!ctx.store.state.resetUser) {
    return ctx.redirect('/auth/login')
  }
}

export const requireVerify = (ctx: Context): void => {
  if (!ctx.store.state.resetUser) {
    return ctx.redirect('/auth/login')
  }
  if (ctx.store.state.resetUser && !ctx.store.state.resetUser.token) {
    return ctx.redirect('/auth/login')
  }
}
